namespace $ { $mol_style_attach( "mol/form/draft/draft.view.css",
 "[mol_form_draft] {\n\twidth: 100%;\n}\n"
) }